/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast */
import { Icon } from 'learning-panel-components';
import { coreService } from 'network-utils';
import { FC } from 'react';
import { translate } from 'translations';
import styles from './learningPathItemContent.module.scss';

const LearningPathItemContent: FC<LearningPathItemContentProps> = (props: LearningPathItemContentProps) => {
    const { type, numberOfItems, isSelected, onSelect, isOpen } = props;
    const typesImages = {
        course: {
            bigImage: `${process.env.PUBLIC_URL}/images/course-circle.webp`,
            smallImage: `${process.env.PUBLIC_URL}/images/courseSmallIcon.svg`,
            name: translate('Courses')
        },
        lesson: {
            bigImage: `${process.env.PUBLIC_URL}/images/lesson-circle.webp`,
            smallImage: `${process.env.PUBLIC_URL}/images/lessonSmallIcon.svg`,
            name: translate('Lessons')
        },
        challenge: {
            bigImage: `${process.env.PUBLIC_URL}/images/challenge_circle.webp`,
            smallImage: `${process.env.PUBLIC_URL}/images/challengeSmallIcon.svg`,
            name: translate('Challenges')
        },
        systemAssessment: {
            bigImage: `${process.env.PUBLIC_URL}/images/assessmentCircleImage.svg`,
            smallImage: `${process.env.PUBLIC_URL}/images/assessmentSmallIcon.svg`,
            name: translate('Assessments')
        }
    };

    return !isOpen ? (
        <div className={styles['item-wrapper']} onClick={() => onSelect(type)}>
            <img
                src={typesImages[type].bigImage}
                style={{ width: '6rem', height: '6rem' }}
                alt="learningPathItemContent"
            />
            <div className={styles['item-content']}>
                <div className={styles['item-title']}>{typesImages[type].name}</div>
                <div className={styles['item-number']}>{numberOfItems}</div>
                <Icon name="chevronDown" />
            </div>
        </div>
    ) : (
        <div
            className={isSelected ? styles['small-item-wrapper-selected'] : styles['small-item-wrapper']}
            onClick={() => onSelect(!isSelected ? type : null)}
        >
            <img src={typesImages[type].smallImage} alt="contentImage" />
            <div className={styles['item-content']}>
                <div className={styles['item-number']}>{numberOfItems}</div>
                <Icon name={isSelected ? 'chevronUp' : 'chevronDown'} />
            </div>
        </div>
    );
};

export interface LearningPathItemContentProps {
    type: coreService.LearningPathContentType;
    numberOfItems: number;
    isSelected: boolean;
    onSelect: Function;
    isOpen: boolean;
}

export default LearningPathItemContent;
